import axios from "../axiosConfig";

class Routes {
  getAppointments(params) {
    return axios.get(`/appointment`, { params });
  }
  getAppointment(id) {
    return axios.get(`/appointment/${id}`);
  }
  getAppointmentByUser(id) {
    return axios.get(`/appointment/user/${id}`);
  }
  addAppointment(data) {
    return axios.post("/appointment", data);
  }
  editAppointment(id, data) {
    return axios.patch(`/appointment/${id}`, data);
  }
  getAppointmentHistory(id) {
    return axios.get(`/appointment/${id}/history`);
  }
  undoAppointment(id) {
    return axios.post(`/appointment/${id}/undo`);
  }
  redoAppointment(id) {
    return axios.post(`/appointment/${id}/redo`);
  }
  markEstimateViewed(id) {
    return axios.patch(`/appointment/${id}/view-estimate`);
  }
  deleteAppointment(id) {
    return axios.delete(`/appointment/${id}`);
  }
  bulkDeleteAppointments(ids) {
    return axios.post("/appointment/bulk-delete", { ids });
  }
  approveAppointment(id) {
    return axios.patch(`/appointment/approve/${id}`);
  }
  getReferralAppointments(id, target) {
    return axios.get(
      `/appointment/referral-appointments?target=${target}&id=${id}`
    );
  }
  getNotifications() {
    return axios.get(`/notification`);
  }
  postNotification(data) {
    return axios.post(`/notification`, data);
  }
}

export default new Routes();
